import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按主题分类的未删减版电影整理，快速找到想看的内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group bg-background-100 border border-background-200/70 hover:border-primary-400/30 rounded-lg p-5 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-400 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-xs text-primary-400">{item.count} 部资源</span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group bg-background-100 border border-background-200/70 hover:border-primary-400/30 rounded-lg p-5 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/10 text-accent-400 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-xs text-accent-400">{item.count} 部资源</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}